import EmailVerify from "components/EmailVerify";

export default EmailVerify;
